import "./Subtotal.css";
import React, { useState, useEffect } from "react";
import CurrencyFormat from "react-currency-format";
import { useStateValue } from "./StateProvider";
import { getBasketTotal } from "./reducer";
import axios from "axios";
import CheckoutButton from "./CheckoutButton";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
function SubtotalWithoutLogin() {
  const [checkOutLabel, setCheckOutLabel] = useState("");
  const [{ basket, user }, dispatch] = useStateValue(); // pull from data layer
  const [sessionId, setSessionId] = useState(null);
  const stripePromise = loadStripe(
    // no need to hide publishable key :
    // "pk_test_51QxaQIGrjbqfgJvWNTXFfAbp3qRBkCjtLnr7xAf2Z0Xx4RCD7viaKHw3zxwovWgXka2MY2jefBQGjZjbOc2tO5J000f77a11O2"
    process.env.REACT_APP_STRIPE_PUBLIC_KEY
  );

  useEffect(() => {
    // if user uses back button to come back from stripe checkout session then empty his basket
    // if (sessionId && user) {
    //
    // 10/25/2025
    // if (sessionId) {
    //   dispatch({
    //     type: "EMPTY_BASKET",
    //   });
    //   setSessionId(null);
    // }

    // if (!user && basket.length > 0) {
    // if user not logged in
    // if ( basket.length > 0) {
    // setCheckOutLabel(
    //   `You must Login before \n you can proceed to check out !`
    // );
    // return;
    // } else
    if (basket.length === 0) {
      setCheckOutLabel(`You must select the item(s) you want to check out !`);
      return;
    }

    axios
      .post(process.env.REACT_APP_STRIPE_CHECKOUT_URL, {
        basket: basket,
        user: user,
      })
      .then((response) => {
        setSessionId(response.data.id);
        // console.log("CHECKING FOR SellerID", response.data);
      })

      .catch((error) => {
        console.error("Error:", error);
      });
  }, [basket]);

  return (
    <div className="subtotal">
      <CurrencyFormat
        renderText={(
          value // see below code , value={  getBasketTotal ( basket )  }
        ) => (
          <>
            <p>Subtotal( {basket.length} items):</p>
            <small className="subtotal__gift">
              <strong> {value} </strong>
              {/* <input type="checkbox" /> */}
              {/* Could this order be a gift */}
            </small>
          </>
        )}
        decimalScale={2}
        value={getBasketTotal(basket)} // getBasketTotal() is a function of the reducer.js
        displayType={"text"} //   configures the diplay of the <> Subtotal , checkbox </> above
        thousandSeparator={true}
        prefix={"$"}
      />
      {/* end of currency format */}
      <Elements stripe={stripePromise}>
        {/* {!user && (
          <h6 className="please-wait">
            Please login ! <br />
            <br /> Or create a username if you haven't
          </h6>
        )}
        {user && !sessionId && <h6 className="please-wait">loading..</h6> && (
          <h6 className="please-wait">please wait...</h6>
        )}
        {user && sessionId && <CheckoutButton sessionId={sessionId} />} */}

        {sessionId ? (
          <CheckoutButton sessionId={sessionId} />
        ) : (
          <h3>Please wait ...</h3>
        )}
      </Elements>
    </div>
  );
}

export default SubtotalWithoutLogin;
